import { render } from "./responses.vue?vue&type=template&id=2de8b41a&scoped=true"
import script from "./responses.vue?vue&type=script&lang=js"
export * from "./responses.vue?vue&type=script&lang=js"

import "./responses.vue?vue&type=style&index=0&id=2de8b41a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2de8b41a"

export default script